<div class="sound-control" (click)="$event.stopPropagation()">
  <button
    class="trigger-btn"
    (click)="togglePanel($event)"
    [attr.aria-label]="currLang === 'ar' ? 'التحكم بالصوت' : 'Sound control'"
    [class.is-muted]="isMuted"
  >
    <ng-container [ngTemplateOutlet]="speakerIcon" [ngTemplateOutletContext]="{ size: 18 }"></ng-container>
  </button>

  <div class="panel" *ngIf="panelOpen" [attr.dir]="currLang === 'ar' ? 'rtl' : 'ltr'">
    <div class="panel-title">
      {{ currLang === 'ar' ? 'الصوت' : 'Sound' }}
    </div>

    <div class="volume-row">
      <button
        class="mute-icon-btn"
        (click)="toggleMute($event)"
        [attr.aria-label]="isMuted ? (currLang === 'ar' ? 'تشغيل الصوت' : 'Unmute') : (currLang === 'ar' ? 'كتم الصوت' : 'Mute')"
        [attr.title]="isMuted ? (currLang === 'ar' ? 'تشغيل' : 'Unmute') : (currLang === 'ar' ? 'كتم' : 'Mute')"
      >
        <ng-container [ngTemplateOutlet]="speakerIcon" [ngTemplateOutletContext]="{ size: 20 }"></ng-container>
      </button>

      <div class="slider-wrap">
        <input
          type="range"
          min="0"
          max="100"
          step="1"
          [value]="volumePercent"
          (input)="onVolumeChange($event)"
          class="vol-slider"
          [class.is-muted]="isMuted"
          [style.--fill]="sliderFillPercent + '%'"
        />
      </div>

      <span class="vol-value">{{ (displayPercent | arabicNumber:currLang) }}%</span>
    </div>
  </div>
</div>

<div class="sound-control-backdrop" *ngIf="panelOpen" (click)="closePanel()"></div>

<ng-template #speakerIcon let-size="size">
  <!-- Muted -->
  <svg *ngIf="isMuted" [attr.width]="size" [attr.height]="size" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path d="M11 5L6 9H3a1 1 0 00-1 1v4a1 1 0 001 1h3l5 4V5z" fill="currentColor"/>
    <line x1="16" y1="9" x2="22" y2="15" stroke="currentColor" stroke-width="2"/>
    <line x1="22" y1="9" x2="16" y2="15" stroke="currentColor" stroke-width="2"/>
  </svg>
  <!-- Low -->
  <svg *ngIf="!isMuted && volumeLevel === 'low'" [attr.width]="size" [attr.height]="size" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path d="M11 5L6 9H3a1 1 0 00-1 1v4a1 1 0 001 1h3l5 4V5z" fill="currentColor"/>
  </svg>
  <!-- Mid -->
  <svg *ngIf="!isMuted && volumeLevel === 'mid'" [attr.width]="size" [attr.height]="size" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path d="M11 5L6 9H3a1 1 0 00-1 1v4a1 1 0 001 1h3l5 4V5z" fill="currentColor"/>
    <path d="M15.5 8.5a5 5 0 010 7" stroke="currentColor" stroke-width="2" fill="none"/>
  </svg>
  <!-- High -->
  <svg *ngIf="!isMuted && volumeLevel === 'high'" [attr.width]="size" [attr.height]="size" viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path d="M11 5L6 9H3a1 1 0 00-1 1v4a1 1 0 001 1h3l5 4V5z" fill="currentColor"/>
    <path d="M15.5 8.5a5 5 0 010 7" stroke="currentColor" stroke-width="2" fill="none"/>
    <path d="M18.5 5.5a9 9 0 010 13" stroke="currentColor" stroke-width="2" fill="none"/>
  </svg>
</ng-template>
